module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.bbrbbr.length) + " registrierte Nutzer\n      "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-up"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": "calc(100vh - 480px)",
      "headers": _vm.headers,
      "items": _vm.bbrbbr,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "no-data-text": "Keine Kontakte vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('tr', {
          staticClass: "hidden-xs-only"
        }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anmeldeID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))])]), _vm._v(" "), _c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))])])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14c61b6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Nutzerverwaltung.vue
// module id = 738
// module chunks = 15